import { ContainerLog } from "../container-log.entity";
import { Container } from "../container.entity";
import { containerLogDto } from "./container-log.dto";

export class ContainerLogAdapter {
    public convertDtoEntity(conLog:containerLogDto):ContainerLog{
       const log = new ContainerLog(); 
        log.containerInfo = new Container();
        log.containerInfo.containerId = conLog.containerId;
        log.containerStatus = conLog.containerStatus;
        if(log.containerLogId){
            log.updatedUser = conLog.updatedUser;
            log.containerLogId = conLog.containerLogId;
        }else{
            log.createdUser = conLog.createdUser;
        }
       return log;
    }
}